var storeUtils = module.exports = {};

storeUtils.get = function (storeId) {
  var storeSelector = '[data-store=' + storeId + ']';
  var store = document.querySelector(storeSelector);
  if (!store) {
    return new Error('This store does not exist on the page: ' + storeId);
  }

  return JSON.parse(store.textContent || store.innerText);
};

storeUtils.messages = function() {
  return storeUtils.get('messages');
};